global.jQuery = require("jquery");
global.$ = global.jQuery;
global.datepicker = require("jquery-datepicker");

var timer;
$(document).ready(function(){
    $(".logout").click(function(){
        window.location.href= "/user/auth/logout/";
    });
    $(".help").click(function(){
        openHelp()
    });
    $("#nav").on("click", ".overview, .admin", function(event){
        event.stopPropagation()
        $(".submenu").hide();
        var elem = $(".submenu", $(this))
        if (elem.hasClass("open")){
            elem.hide();
            elem.removeClass("open")
        }
        else {
            elem.show(0,function(){
            elem.addClass("open")
            var menu = $(this);
            $("html, body").click(function(){
                menu.hide();
                elem.removeClass("open")
            })
        })
        }
    });
});
function liveSum(url, form){
	var url = url;
	var data = $(form).serialize();
	$.ajax({
		url: url,
		type: "post",
		data: data,
		success: function(response){
			if (response.status == "success"){
				myLoop(1, parseInt($(".popup .number").text()), response.html, response.unit)
			}
		}
	})
}
function myLoop (i, from, to, unit) {
	var from = from;
	var to = to;
	var dif;
	var from_string;
	setTimeout(function () {
		dif = (to-from)/15;
		from = from+dif;
		from = Math.round(from)
		$(".popup .number").html(from+"<span class='unit'>"+unit+"</span>")
		var length = $(".popup .number").text().length - $(".unit").text().length
		if (length > 3){
			$(".popup .number").addClass("smallNumber");
		}
		else{
			$(".popup .number").removeClass("smallNumber");
		}
		i++;
		if (i < 15) {
			myLoop(i, from, to, unit);
		}
		else {
			$(".popup .number").html(to+"<span class='unit'>"+unit+"</span>")
			var end_length = $(".popup .number").text().length - $(".unit").text().length;
			if (end_length > 3){
				$(".popup .number").addClass("smallNumber");
			}
			else {
				$(".popup .number").removeClass("smallNumber");
			}
		}
   }, 20)
}
function updateOverview(url){
	var navurl = url;
	$(".wideContent .overviewCon").load(navurl+" .wideContent .overview", function(){
		//Fjern dette ved ie8 udfasning
		var t = setTimeout(function(){
			$(".wideContent").addClass("test").removeClass("test");
		},500)
	});
}
function validateForm(chosenForm){
	chosenForm.validate({
				submitHandler: function(form){
				$(".logActivityBtn").removeClass("logActivityBtn").addClass("logActivityBtnDisabled");
				var loader = new spinner("big", "", $(".popup .message"), false);
				loader.start();
				$(".popup .message").slideDown("fast");
				var url = $(form).attr("action");
				var data = $(form).serialize();
				$.ajax({
					url: url,
					type: "post",
					data: data+"&log_employee="+$(".selectEmp").val()+"&tci="+$(".column2 .columnContent .selected").attr("id"),
					success: function(response){
						if (response.status == "success"){
							//Hvis vi er på oversigten skal den opdateres
							if ($(".wideContent .overview").length != 0){
								var id = $(".wideContent .overview").attr("name");
								var url = $(".pageNav .heading").attr("name");
								updateOverview(url);
								//$(".wideContent .overviewCon").load("/view/ajax/employees/"+id+"/years/"+year+"/ .wideContent .overview");
							}
							$(".popup .message").html("<p><span class='text'>Registrering blev gemt.</span></p>");
							var t = setTimeout(function(){
								closePopup();
							}, 800);
							var i = 3;
							// function countDown(){
							// 	var secs = parseInt($(".secs").text());
							// 	var newNumber = secs-1;
							// 	timer = setTimeout(function(){
							// 		$(".secs").text(newNumber);
							// 		i--;
							// 			if (i > 0){
							// 				countDown();
							// 			}
							// 			else {
							// 				closePopup();
							// 			}
							// 	}, 1000);
							// }
							// countDown();
						}
						if (response.status == "error"){
							$(".popup").html(response.html)
							$(".logActivityBtnDisabled").removeClass("logActivityBtnDisabled");
							$(".datePicker").datepicker({dateFormat: "dd/mm/yy"});
							var calc_url = $(".log").attr("name")
							$(".calc").keyup(function(){
								$(".calculated-sum .number").html(liveSum(calc_url, $(".popup form")));
							})
							$(".myradio").change(function(){
								$(".calculated-sum .number").html(liveSum(calc_url, $(".popup form")));
							})
						}
					}
				})
				}
			});
	chosenForm.submit();
}
function addEditHelpText(){
	 $('.helptext.edit').editable(function(value, settings) {
	 var newValue;
	 $.ajax({
     	url: "/staff/ajax/activities/"+this.id+"/edit.json/",
     	type: "post",
     	async: false,
     	data: "field=help_text&value="+value,
     	success: function(response){
     		newValue = response.value;
     	}
     })
     return(value);
  }, {
     type    : 'textarea',
     submit  : 'OK',
     cancel: "Fortryd indtastning",
     indicator: "Gemmer tekst"
 });
}
function makeLayer(){
	var width = $(document).width();
	var height = $(document).height();
	$(".layer").css({
		"width": width,
		"height": height,
		"opacity":"0.3"
	}).fadeIn()
}
function closePopup(){
	clearTimeout(timer);
	$(".popup").empty().hide();
	$(".wideContent").removeClass("overlay");
	closeLayer();
}
function closeLayer(){
	$(".layer").hide();
}
function openHelp(){
	closePopup();
	makeLayer();
	$(".popup").load("/department/faq/", function(){
		// $.getScript(media_url+"/images/js/client/fileuploader.js", function(){
		// 	$.getScript(media_url+"/images/js/client/upload.js")
		// })
		$("body").bind("keydown", function(e){
				if (e.which == 27){
					closePopup()
				}
			});
		$(".close").click(function(){
			closePopup();
		})
		$("#helpForm").submit(function(e){
			e.preventDefault()
			var loader = new spinner("big", "", $(".formSpinner"));
			loader.start();
			$.ajax({
				url: "/department/faq/submitticket/",
				type: "post",
				data: $("#helpForm").serialize(),
				success: function(response){
					loader.stop(true)
					if (response.status == "error"){
						$(".formCon").html(response.html)
					}
					if (response.status =="success"){
						$(".formMessage").text("Din henvendelse er blevet sendt. Vi vender tilbage til dig hurtigst muligt.")
						$("#id_email, #id_subject, #id_description").val("")
					}
				}
			})
		})
	})
	$(".popup").css({"top":100})
	$(".popup").fadeIn(function(){

	});
}
function spinner(size, style, container, replace){
	this.size = size;
	this.style = style;
	this.container = container;
	this.smallSpinner = $(".spinner.small");
	this.medSpinner = $(".spinner.medium");
	this.bigSpinner = $(".spinner.big");
	this.currentSpinner;
	this.start = start;
	this.stop = stop;
	function start(){
		switch (this.size){
			case "small":
				this.currentSpinner = this.smallSpinner;
				break;
			case "medium":
				this.currentSpinner = this.medSpinner;
				break;
			case "big":
				this.currentSpinner = this.bigSpinner;
				break;
		}
		if (replace){
			$(this.currentSpinner).clone().appendTo(".spinnerCon");
			$(this.container).replaceWith(this.currentSpinner);
		}
		else {
			$(this.currentSpinner).clone().appendTo(".spinnerCon");
			$(this.container).append(this.currentSpinner);
		}
		//$(this.currentSpinner).css(this.style)
		this.currentSpinner.show();
	}
	function stop(hide){
		//$(this.currentSpinner).clone().appendTo(".spinnerCon");
		if (hide){
			this.currentSpinner.remove();
		}

	}
}
jQuery.fn.vertical_center = function () {
    this.css("position","absolute");
    this.css("top", Math.max(0, (($(window).height() - this.outerHeight()) / 2) +
                                                $(window).scrollTop()) + "px");
    return this;
}
global.openHelp = openHelp;
global.spinner = spinner;
global.makeLayer = makeLayer;
global.addEditHelpText = addEditHelpText;
global.liveSum = liveSum;
global.closePopup = closePopup;
global.validateForm = validateForm;
global.myLoop = myLoop;
global.updateOverview = updateOverview;
global.vertical_center = jQuery.fn.vertical_center;
global.closeLayer = closeLayer;
